/** @format */
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sis-technical-message-view',
    standalone: false,
    templateUrl: './technical-message-view.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TechnicalMessageViewComponent {
    @Input() title: string;
    @Input() message: string;

    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    copyToClipboard() {
        this.document.defaultView.navigator.clipboard.writeText(this.message).then(() => console.log('Copied to clipboard'));
    }
}
